import React from 'react'
import { useParams } from 'react-router-dom';
import { Col, Row, Skeleton } from 'antd';
import ExamStep from './Exams/ExamStep';
import ConsultationStep from './Consultations/ConsultationStep';
import SurveyDisclaimer from './SurveyDisclaimer';

export default function CurrentStep({ stepHandler, goToTabs, hasSurvey, isLoading, getLocalStorageData }) {
  const { countryCode } = useParams();

  return (
    <Row>
      <Col span={24}>
        <Skeleton loading={isLoading} active>
        {
          (!goToTabs && hasSurvey) ?
            <SurveyDisclaimer examName={getLocalStorageData.surveyExam?.name} />
          :
            (stepHandler.currentStep === 0) ?
              <ExamStep
                stepHandler={stepHandler}
                getLocalStorageData={getLocalStorageData}
                countryCode={countryCode}
              />
            :
              <ConsultationStep
                countryCode={countryCode}
                stepHandler={stepHandler}
                getLocalStorageData={getLocalStorageData}
              />
        }
        </Skeleton>
      </Col>
    </Row>
  );
};
